import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
    components: {
        MUIDataTableFilter: {
            styleOverrides: {
                root: {
                    width: "800px",
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    justifyContent: "center"
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    textAlign: "center",
                    fontSize: "1.875rem",
                    lineHeight: "2.25rem",
                    fontWeight: 400,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    "& .MuiButton-root": {
                        textTransform: "none",
                        minWidth: 0,
                        justifyContent: "flex-start",
                    },
                },
            },
        },
    },
    palette: {
        primary: {
            main: "#556cd6",
        },
        secondary: {
            main: "#19857b",
        },
        error: {
            main: red.A400,
        },
    },
});

export default theme;
